<template>
	<div class="performance">
		<div class="performance__heading">
			<h2 class="performance__title">PERFORMANCE</h2>
			<a
				:data-toggle="isMobile ? '' : 'modal'"
				:data-target="isMobile ? '' : '#read-more-modal'"
				class="text-purple read-more-link pointer"
				@click="showDisclaimerFPS = isMobile"
			>
				<img
					src="/images/icons/tooltip-help-icon-white.svg"
					alt="Performance Help"
					class="performance__tooltip"
				>
			</a>
		</div>
		<div class="performance__games">
			<game-fps-item
				v-for="game in games"
				:key="`fps-game-${game.id}`"
				:game="game"
				:fps="gamesFps[game.id]"
				:only-recommended-fps="onlyRecommendedFps"
			/>
		</div>

		<div class="performance__pending-fps-msg" v-if="showFpsPendingMobile">
			<h5>FPS pending</h5>
			<p>{{ fpsPendingMessage }}</p>
		</div>

		<hr>
		<p class="performance__note">
			FPS speeds are measured using a {{ resolutionText }} resolution using each game’s highest graphic setting.
			<a
				:data-toggle="isMobile ? '' : 'modal'"
				:data-target="isMobile ? '' : '#read-more-modal'"
				class="text-purple read-more-link pointer"
				@click="showDisclaimerFPS = isMobile"
			>
				Read More
			</a>
		</p>

		<!-- modals -->
		<div
			id="read-more-modal"
			class="modal fade in"
			tabindex="-1"
			role="dialog"
			v-if="!isMobile"
		>
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body text-white">
						<div class="p-x p-y text-center text-white">
							<h2>MORE INFO</h2>
							<p class="text-light">
								{{ fpsDisclaimer }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<drawer-modal v-model="showDisclaimerFPS" v-if="isMobile">
			{{ fpsDisclaimer }}
		</drawer-modal>
		<!-- /.modals -->
	</div>
</template>

<script>
import GameFpsItem from "./game-fps-item";
import DrawerModal from "./drawer-modal";
import { isMobile, onTouchStartMakeClick } from "@u/helpers.js";
import CONSTANTS from "@/config/constants";

export default {
	name: "GameFpsList",
	components: {
		GameFpsItem,
		DrawerModal
	},
	props: {
		games: {
			type: Array,
			required: true
		},
		gamesFps: {
			type: Object,
			default: () => ({})
		},
		resolutionText: {
			type: String,
			required: true
		},
		onlyRecommendedFps: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showDisclaimerFPS: false,
			isMobile: false,
			fpsPendingMessage: CONSTANTS.FPS_PENDING_MESSAGE
		};
	},
	computed: {
		fpsDisclaimer() {
			return `Predicted Frames Per Second speeds are measured using a ${ this.resolutionText }
			resolution using each game's highest graphic setting.
			FPS is a measurement of the PC's game performance in game.
			BLD guarantees all predictions for games within an accuracy of +/- 10%.`;
		},
		showFpsPendingMobile() {
			return Object.values(this.gamesFps).some(fps => fps == 0);
		}
	},
	created() {
		this.isMobile = isMobile();
	},
	mounted() {
		onTouchStartMakeClick(".read-more-link", () => {
			this.click();
		});
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.performance {
	&__heading {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__title {
		color: $white;
		font-size: 24px;
		font-weight: bold;
		margin-top: 0;
		margin-bottom: 30px;
		text-transform: uppercase;

		@media (max-width: 580px) {
			font-size: 20px;
			margin: 20px 0;
		}
	}

	&__tooltip {
		display: none;
	}

	&__games {
		@media (max-width: 991px) {
			display: flex;
			flex-direction: column;
		}
	}

	hr {
		display: none;
	}

	&__pending-fps-msg {
		display: none;
		color: #FFFFFF;
		font-size: 16px;
		line-height: 21px;

		@media (max-width: 991px) {
			display: block;
		}

		h5 {
			letter-spacing: 0;
			font-weight: bold;
			margin: 0 0 5px;
		}

		p {
			margin: 0;
		}
	}

	&__note {
		font-size: 16px;
		line-height: 22px;
		margin-top: 25px;
		color: $white;
		font-family: Akkurat-Light;

		a {
			color: $orchid;
			font-weight: bold;
		}

		@media (max-width: 991px) {
			margin-top: 15px;
		}
	}
}

[data-config-step="3"] {
	.performance {
		&__title {
			@media (max-width: 580px) {
				font-size: 14px;
				margin: 20px 0;
			}
		}

		@media (max-width: 991px) {
			&__tooltip {
				display: block;
			}

			&__note {
				display: none;
			}

			&__games {
				flex-direction: row;
				justify-content: center;
				margin-bottom: 10px;
			}

			hr {
				display: block;
			}
		}


	}
}
</style>
